<template>
  <div>
    <div class="noticeBar02" v-if="settingConfig.ShowStatistics">
      <div class="left">
        <div class="warp-title">
          <img src="@/assets/img/icon08.png" style="width: 20px; margin-right: 5px;"/>
          营收数据统计
        </div>
        <el-button type="primary" @click="handleReLoad">
          <img src="@/assets/img/icon01.png" style="width: 14px; margin-right: 5px;"/>
          刷新
        </el-button>
      </div>
      <div class="right">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide class="list" v-for="(v, i) in message" :key="i">
            <dl @click="handleDialog(v.name === '欠费')">
              <dd><img :src="require(`@/assets/img/${v.img}.png`)" style="width: 50px; margin-right: 5px;"/></dd>
              <dt>
                {{v.name}}
                <div><span>{{v.value}}</span>{{v.unit}}</div>
              </dt>
            </dl>
            <el-divider direction="vertical" v-if="i < 4"></el-divider>
          </swiper-slide>
          <!--        <div class="swiper-pagination" slot="pagination"></div>-->
        </swiper>
        <!--
        <div class="box">
          <div class="list" v-for="(v, i) in message" :key="i">
            <dl>
              <dd><img :src="require(`@/assets/img/${v.img}.png`)" style="width: 50px; margin-right: 5px;"/></dd>
              <dt>
                {{v.name}}
                <div><span>{{v.value}}</span>{{v.unit}}</div>
              </dt>
            </dl>
            <el-divider direction="vertical" v-if="i < 4"></el-divider>
          </div>
        </div>-->
      </div>
    </div>
    <div class="no-notice-bar02" v-else>
      <div class="box">
        <span>平台介绍</span>
        <div>平台基于云计算，集中管理停车场车辆；岗亭道闸智能识别无牌车扫码进出场；支持实时查看车辆通行记录和在停情况并可实时监管硬件设备状态</div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { noticeBarPubSub } from "@/service/pubsub/index";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      message: '',
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 0,
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      }
    }
  },
  props: {
    gateArrStr: {
      type: [Array, String],
      default: undefined,
    },
  },
  computed: {
    tenantInfo: function () {
      return this.$store.state.user.userInfo;
    },
    isCashier: function () {
      return this.$store.state.user.isCashier;
    },
    settingNotice: function () {
      return this.$store.state.user.settingNotice;
    },
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    settingConfig: function () {
      return this.$store.state.layout.settingConfig;
    },
  },
  watch: {
    settingNotice: {
      handler(val){
        let arr = JSON.parse(val);
        if (arr.length > 5) {
          this.swiper.autoplay.start();
        } else {
          this.swiper.autoplay.stop();
        }
      },
      deep:true
    }
  },
  mounted() {
    noticeBarPubSub.subscribe(this.getInfo);
  },
  methods: {
    getInfo(msg) {
      this.message = msg;
    },
    handleReLoad() {
      this.$store.dispatch("SetIsSentryStatement", true);
      setTimeout(() =>{
        this.$store.dispatch("SetIsSentryStatement", false);
      }, 100)
    },
    handleDialog(bool) {
      if (bool)this.$store.dispatch("SetShowArrearsDialog", true);
    },
  },
};
</script>

<style lang="scss">
  .noticeBar02{
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0 20px 20px;
    .left{
      width: 136px;
    }
    .right{
      width: calc(100% - 136px);
      overflow-x: auto;
      .box{
        overflow: hidden;
      }
    }
    .list{
      float: left;
      display: flex;
      width: 180px;
      justify-content: center;
      align-items: center;
      position: relative;
      .el-divider--vertical{
        height: 2.5em;
        background-color: #E5E5E5;
        margin: 0;
        position: absolute;
        right: 0;
      }
    }
    .warp-title{
      margin-bottom: 16px;
    }
    dl{
      margin: 0;
      display: flex;
      dd{
        margin: 0;
      }
      dt{
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        position: relative;
        div{
          color: #909399;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          position: absolute;
          width: 100%;
          bottom: 0;
          span{
            font-size: 20px;
            font-weight: 500;
            color: #333333;
          }
        }
      }
    }
  }
</style>
